import React from "react";

const CustomSelect = ({ options, selectedValue, onChange, isOpen, onToggle }) => {
  console.log("options", options)
  return (
    <div className="custom-select">
      <div className="custom-select-button" onClick={onToggle}>
        {selectedValue}
      </div>
      {isOpen && (
        <div className="custom-select-options">
          {options.map((option, index) => (
            <div
              key={index}
              className="custom-select-option"
              onClick={() => {
                onChange(option);
                onToggle();
              }}
            >
              {typeof option === "string" ? (
                option
              ) : (
                <>
                  <p>
                    {option.name}
                  </p>
                  {option.tags && option.tags.length > 0 && (
                    <span className="badge-button">
                      <p>{option.tags}</p>
                    </span>
                  )}


                </>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default CustomSelect;
